'use client';
import ReserveSeeNotify from '@/components/shared/ReserveSeeNotify/ReserveSeeNotify';
import Typography from '@/components/shared/typography/typography.component';
import { useState } from 'react';
import { useTranslation, useWindowDimensions } from '@/hook';
import {
    CalendarCardIcon,
    Speedometer,
    TransmissionIcon,
} from '../../../../../public/Images';
import BadgeWithTooltip, {
    EBadgeWithTooltip,
} from '@/components/shared/badege-with-tooltip/badge-with-tooltip.component';
import WhatsIncluded from '@/components/shared/WhatsIncluded/whats-included.component';
import Modal from '@/components/shared/modal.component';
import { DisplayedCarInfoInterface, EReservationTagsVariants } from '@/types';
import { numberWithCommas } from '@/utils';
import NotifyMe from '../NotifyMe';
import {
    CarProfileCarName,
    CarProfileCurrency,
    CarProfileInfoContainer,
    CarProfileInstallmentPrice,
    CarProFileMoreInfoContainer,
    CarProFileMoreInfoItemContainer,
    CarProfileMoreInfoText,
    CarProfileSubtitle,
    CarProfileTrim,
} from '../StyledComponents/car-info-section-components';
import CarSoldOverlay from '../SimilarCars/CarSoldOverlay';
import SoldBadge from '@/components/shared/SoldBadge/sold-badge.component';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import ShowroomSection from './ShowroomSection/ShowroomSection';
import colors from '@/theme/colors.module.scss';
import styles from './styles.module.scss';
import {
    AVAILABLE_LANGUAGES,
    FEATURE_FLAG_RESERVATION_TAGS,
} from '@/constants';
import { TemporaryReserveBadge } from '@/components/shared/car-details-card/car-details-car-client.component';
import { useFeatureValue } from '@growthbook/growthbook-react';
import trendDownAR from '../../../../../public/Images/CarCard/trendDownAr.svg';
import trendDownEN from '../../../../../public/Images/CarCard/trendDownEn.svg';
import Conditional from '@/components/shared/conditional/conditional.component';

const MorInfo = ({
    kilometers,
    transmission,
    year,
}: {
    kilometers: string | number;
    year: number;
    transmission: string;
}) => {
    const { t } = useTranslation();
    return (
        <CarProFileMoreInfoContainer>
            <CarProFileMoreInfoItemContainer>
                <Image src={Speedometer} alt="Speedometer" />
                <CarProfileMoreInfoText variant={'body2'}>{`${numberWithCommas(
                    kilometers
                )} ${t('km')}`}</CarProfileMoreInfoText>
            </CarProFileMoreInfoItemContainer>
            <CarProFileMoreInfoItemContainer>
                <Image src={CalendarCardIcon} alt="CalendarCardIcon" />
                <CarProfileMoreInfoText variant={'body2'}>
                    {year}
                </CarProfileMoreInfoText>
            </CarProFileMoreInfoItemContainer>
            <CarProFileMoreInfoItemContainer>
                <Image src={TransmissionIcon} alt="TransmissionIcon" />
                {/*
          @eslint-disable-next-line @typescript-eslint/ban-ts-comment
          @ts-ignore */}
                <CarProfileMoreInfoText variant={'body2'}>
                    {t(transmission)}
                </CarProfileMoreInfoText>
            </CarProFileMoreInfoItemContainer>
        </CarProFileMoreInfoContainer>
    );
};
const PricingSection = ({
    sylndrSellingPrice,
    installmentPrice,
    discountPrice,
    registrationFees,
}: {
    sylndrSellingPrice: string | number;
    installmentPrice: string | number;
    discountPrice: number;
    registrationFees?: number;
}) => {
    const { t, IS_RTL } = useTranslation();
    const { IS_DESKTOP } = useWindowDimensions();
    const carPriceSubSection = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
    };
    const carPriceSubSectionText = {
        display: 'flex',
        alignItems: 'baseline',
    };
    const hasDiscount = discountPrice !== undefined && discountPrice !== 0;
    // const differencs = Math.trunc(
    //     parseFloat(sylndrSellingPrice as string) - discountPrice
    // );

    const formatDiscountAsPercentage = (
        before: string | number,
        after: number
    ) => {
        before = parseInt(before.toString(), 10);
        const percentage = Math.abs(
            Math.ceil(((before - after) / before) * 100)
        );
        if (percentage === 0) {
            return '';
        }

        return IS_RTL
            ? `%${percentage.toLocaleString()} أقل من أسعار فبراير`
            : `${percentage.toLocaleString()}% decrease from Feb Market Prices`;
    };
    // const discountPercentage = formatNumber(differencs);
    const discountPercentage = formatDiscountAsPercentage(
        sylndrSellingPrice,
        discountPrice
    );

    const displayedPrice = hasDiscount
        ? discountPrice.toString()
        : sylndrSellingPrice;
    return (
        <div className={styles.priceSectionContainer}>
            {IS_DESKTOP && (
                <CarProfileSubtitle variant={'body2Medium'}>
                    {t('pricing')}
                </CarProfileSubtitle>
            )}
            <Conditional condition={!!(hasDiscount && discountPercentage)}>
                <div
                    style={{
                        display: 'flex',
                        alignContent: 'flex-end',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        gap: '4px',
                    }}
                >
                    <div style={{ display: 'flex' }}>
                        <Typography
                            variant={'caption'}
                            className={
                                IS_RTL ? 'strikethroughAr' : 'strikethrough'
                            }
                            style={{
                                fontWeight: '600',
                                marginInline: '2px',
                                fontSize: '1rem',
                                color: '#B54708',
                                display: 'none',
                            }}
                        >
                            {`${numberWithCommas(sylndrSellingPrice)}`}
                        </Typography>
                        <Typography
                            style={{
                                marginInline: '2px',
                                color: '#B54708',
                                display: 'none',
                            }}
                            variant={'caption'}
                        >
                            {t('EGP')}
                        </Typography>
                    </div>
                    <div
                        style={{
                            backgroundColor: '#D0FADF',
                            padding: ' 2px 6px 2px 6px',
                            borderRadius: '5px',
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            width: 'max-content',
                            marginInline: '2px',
                            gap: '4px',
                        }}
                    >
                        <Image
                            src={IS_RTL ? trendDownAR : trendDownEN}
                            alt={'decrease'}
                            width={18}
                            height={18}
                        />
                        <Typography
                            style={{
                                opacity: 1,
                                fontSize: '0.75rem',
                                lineHeight: '1.25rem',
                                color: '#2A7A47',
                                marginTop: '1px',
                            }}
                            variant={'subtitle1SemiBold'}
                        >
                            {`${discountPercentage}`}
                        </Typography>
                    </div>
                </div>
            </Conditional>
            <div style={carPriceSubSection}>
                <div style={carPriceSubSectionText}>
                    <CarProfileCurrency variant={'body2'}>
                        {t('EGP')}
                    </CarProfileCurrency>
                    <Typography
                        variant={'h6SemiBold'}
                        color={colors.secondary500}
                    >
                        {numberWithCommas(displayedPrice as string)}
                    </Typography>
                </div>
                {installmentPrice && (
                    <CarProfileInstallmentPrice variant={'body2Medium'}>
                        {t('from')} {numberWithCommas(installmentPrice)}
                        {t('/month')}
                    </CarProfileInstallmentPrice>
                )}
            </div>
            <div className={styles.whatsIncluded}>
                <WhatsIncluded
                    hideToolTip={!IS_DESKTOP}
                    registrationFees={registrationFees}
                />
            </div>
        </div>
    );
};

const CarInfo = ({ carInfo }: { carInfo: DisplayedCarInfoInterface }) => {
    const { i18n } = useTranslation();
    const { width } = useWindowDimensions();
    const lang = i18n.language;
    const IS_RTL = lang === 'ar';
    const isDesktop = width > 850;
    const [notifyMeModal, setNotifyModal] = useState(false);
    const router = useRouter();
    const reservationTagVariant = useFeatureValue(
        FEATURE_FLAG_RESERVATION_TAGS,
        EReservationTagsVariants.ORIGINAL
    );

    const seeCarButtonClicked = () => {
        if (carInfo?.id === undefined) return;
        router.push(
            `/${i18n.language}/car-details/${carInfo?.id}/checkout/see`
        );
    };
    const handleBadge = () => {
        if (
            !carInfo?.isPurchaseInProgress &&
            carInfo?.isReserved &&
            reservationTagVariant &&
            reservationTagVariant != EReservationTagsVariants.ORIGINAL
        )
            return <TemporaryReserveBadge />;
        if (carInfo?.isSold) return <SoldBadge />;
        if (carInfo?.isPurchaseInProgress)
            return (
                <BadgeWithTooltip
                    type={EBadgeWithTooltip.PURCHASE_IN_PROGRESS}
                />
            );
        if (carInfo?.isReserved)
            return <BadgeWithTooltip type={EBadgeWithTooltip.RESERVED} />;
        return '';
    };

    return (
        <>
            <CarProfileInfoContainer>
                <div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'space-between',
                            position: 'relative',
                            flexDirection: 'column',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                justifyContent: 'space-between',
                                position: 'relative',
                                flexDirection: 'row',
                                width: '100%',
                            }}
                        >
                            <div>
                                <CarProfileCarName variant="subtitle2SemiBold">{`${carInfo?.make} ${carInfo?.model} ${carInfo?.year}`}</CarProfileCarName>
                                {carInfo?.trim && (
                                    <CarProfileTrim variant={'body2'}>
                                        {IS_RTL
                                            ? carInfo?.trim?.ar
                                            : carInfo?.trim?.en}
                                    </CarProfileTrim>
                                )}
                            </div>
                            {handleBadge()}
                        </div>

                        {(isDesktop ||
                            ((carInfo.isSold || carInfo.isPurchaseInProgress) &&
                                !isDesktop)) && (
                            <MorInfo
                                kilometers={carInfo?.kilometers}
                                year={carInfo?.year}
                                transmission={carInfo?.transmission}
                            />
                        )}
                    </div>
                </div>
                {carInfo.showroom &&
                !carInfo.isPurchaseInProgress &&
                !carInfo.isSold &&
                isDesktop ? (
                    <ShowroomSection
                        showroom={carInfo.showroom}
                        lang={lang as AVAILABLE_LANGUAGES}
                        isDesktop={isDesktop}
                        carInfo={carInfo}
                        setNotifyModal={setNotifyModal}
                        seeCarButtonClicked={seeCarButtonClicked}
                    />
                ) : null}
                {(isDesktop ||
                    !(carInfo?.isSold || carInfo.isPurchaseInProgress)) && (
                    <div className={styles.pricingContainer}>
                        {(carInfo?.isSold || carInfo.isPurchaseInProgress) &&
                            isDesktop && (
                                <CarSoldOverlay
                                    type={
                                        carInfo.isPurchaseInProgress
                                            ? 'PURCHASE_IN_PROGRESS'
                                            : 'SOLD'
                                    }
                                    style={{
                                        marginLeft: '-16px',
                                        marginRight: '-16px',
                                        marginBottom: '-24px',
                                        marginTop: '-16px',
                                    }}
                                />
                            )}

                        <PricingSection
                            sylndrSellingPrice={carInfo?.sylndrSellingPrice}
                            installmentPrice={carInfo?.installmentPrice}
                            discountPrice={carInfo?.discountPrice}
                            registrationFees={carInfo?.registrationFees || 0}
                        />

                        {!isDesktop && (
                            <MorInfo
                                kilometers={carInfo?.kilometers}
                                year={carInfo?.year}
                                transmission={carInfo?.transmission}
                            />
                        )}
                        {carInfo.showroom &&
                        !carInfo.isPurchaseInProgress &&
                        !carInfo.isSold &&
                        !isDesktop ? (
                            <ShowroomSection
                                showroom={carInfo.showroom}
                                lang={lang as AVAILABLE_LANGUAGES}
                                isDesktop={isDesktop}
                                carInfo={carInfo}
                                setNotifyModal={setNotifyModal}
                                seeCarButtonClicked={seeCarButtonClicked}
                            />
                        ) : null}
                        {isDesktop ? (
                            <ReserveSeeNotify
                                carInfo={carInfo}
                                isDesktop={isDesktop}
                                lang={lang}
                                setNotifyModal={setNotifyModal}
                                seeCarButtonClicked={seeCarButtonClicked}
                                showTip={true}
                            />
                        ) : null}
                        <Modal
                            open={notifyMeModal}
                            sx={{
                                backdropFilter: 'blur(6px)',
                                borderRadius: '12px',
                            }}
                            setOpen={setNotifyModal}
                        >
                            <NotifyMe
                                setModal={setNotifyModal}
                                carId={carInfo?.id}
                            />
                        </Modal>
                    </div>
                )}
            </CarProfileInfoContainer>
        </>
    );
};
export default CarInfo;
